export default __webpack_public_path__ + "static/media/Lofi3.190cb803.mp3";